// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"732":"7b672541","859":"44b53713"}[chunkId] + ".chunk.css";
};